var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AboutUs"},[_vm._m(0),_c('AboutUsPart1'),_c('AboutUsPart2'),_c('AboutUsPart3'),_c('AboutUsPart4')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"constent"},[_c('div',{staticClass:"header_nav"},[_c('div',[_vm._v("赋能品牌力量   呈现美好生活")]),_c('div',[_vm._v("客 户 满 意   |  员 工 温 暖  |  同 业 尊 敬  |  社 会 认 可")])])])
}]

export { render, staticRenderFns }